import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class' ;
import { ActivityStatus } from '../../common/enums';
import * as JSONPatch from 'fast-json-patch';
import { IPagination } from '../../models/generic';
import { TICKET_MODULE_NAMESPACE, TICKET_LOADERS } from '../../store/ticket';
import { BLOCK_LOADERS, BLOCK_MODULE_NAMESPACE } from '../../store/block';
import { RECEPTION_MODULE_NAMESPACE, RECEPTION_LOADERS } from '../../store/reception/reception-types.store';
import { Route } from 'vue-router';
import {BM_LOADERS, BM_MODULE_NAMESPACE} from "../../store/building-monitor/bm-types.store";

const TicketStore= namespace(TICKET_MODULE_NAMESPACE)
const BlockStore= namespace(BLOCK_MODULE_NAMESPACE)
const ReceptionStore= namespace(RECEPTION_MODULE_NAMESPACE)
const BMStore= namespace(BM_MODULE_NAMESPACE)

@Component({
  components: {
    'v-infinite-loading': async () => import('vue-infinite-loading'),
    'no-record': async () => import('../empty/Empty.vue')
  }
})
class InfinityLoadingComponent extends Vue {

  _clearTimeout: any;
  dtLoading: boolean;
  dtIsFirstLoad: boolean;
  dtInternalSkipNumber: number;
  dtPreviousParameter: any;
  /**
   *
   */
  constructor() {
    super();
    this.dtIsFirstLoad = (this.coPagination.total === 0) || true;
    this.dtInternalSkipNumber = 0;
  }
  @Prop({
    default: () => ({ total: 0, limit: 10, skip: 0, isDefault: true }),
    type: [Object],
    required: false
  })
  pagination: { total: number, limit: number, skip: number, isDefault: boolean }


  @Prop({ default: false, type: [Boolean] })
  loadingEnable: boolean;
  @Prop({ default: 500, type: [Number] })
  debonce: number;

  @Prop({ default: true, type: [Boolean] })
  defaultContainer: boolean;
  @Prop({ default: false, type: [Boolean] })
  force: boolean;

  @Prop({ default: ActivityStatus.Loading, type: [Number] })
  activityStatus: ActivityStatus;

  @Prop({ required: true, type: [Function] })
  onFetch: Function;
  @Prop({ required: false, type: [Function] })
  resetBeforeDestroy: Function;
  @Prop({ required: true, type: [Object] })
  parameter: any;
  @Prop({ required: false, default: () => [], type: [Array] })
  source: any[];
  @Prop({ required: false, type: [Function] , default: ()=> function(){}  })
  setLoaderState: Function

  @TicketStore.Getter('loaders') ticket_loaders: Map<string,boolean>
  @BlockStore.Getter('loaders') block_loaders: Map<string,boolean>
  @ReceptionStore.Getter('loaders') reception_loaders: Map<string,boolean>
  @BMStore.Getter('loaders') bm_loaders: Map<string,boolean>

  get coParameter() {
    return this.parameter;
  }
  get coPagination(): IPagination {
    return this.pagination;
  }
  get isLoading(): boolean {
    return this.activityStatus === ActivityStatus.Loading;
  }
  get visible(): boolean {
    console.log('this.coPagination.skip', this.coPagination.skip)
    console.log('this.dtInternalSkipNumber', this.dtInternalSkipNumber)
    console.log('this.pagination.limit', this.pagination.limit)
    console.log('this.pagination.total', this.pagination.total)
    console.log('this.isLoading', this.isLoading)
    console.log('this.activityStatus', this.activityStatus)
    console.log('this.coPagination.total', this.coPagination.total)
    console.log('this.dtIsFirstLoad', this.dtIsFirstLoad)
    console.log('this.this.source.length', (this.source || []).length)
    console.log('visible', (
        (this.isLoading === false &&
          (
            (this.activityStatus === ActivityStatus.LoadFailed) ||
            (this.activityStatus === ActivityStatus.Loaded)
            && this.coPagination.total > 0
          )
          && this.source.length < this.coPagination.total
        ) ||
        this.activityStatus === ActivityStatus.NoActivity
        || (
          this.dtIsFirstLoad
          && this.pagination.limit > this.pagination.total)
      )
      && (this.coPagination.skip < this.coPagination.total || this.coPagination.total === 0))

    return (
      (this.isLoading === false &&
        (
          (this.activityStatus === ActivityStatus.LoadFailed) ||
          (this.activityStatus === ActivityStatus.Loaded)
        && this.coPagination.total > 0
        )
        && this.coPagination.limit < this.coPagination.total
      ) ||
      this.activityStatus === ActivityStatus.NoActivity
      || (
          this.dtIsFirstLoad
          && this.pagination.limit > this.pagination.total)
        )
      && (this.coPagination.skip < this.coPagination.total || this.coPagination.total === 0);
  }

  get coLoader(): boolean {
    console.log('Ticket loaders = ', this.ticket_loaders)
    console.log('bm_loaders = ', this.bm_loaders)
    return this.ticket_loaders.get(TICKET_LOADERS.LIST)
        || this.block_loaders.get(BLOCK_LOADERS.LIST)
        || this.reception_loaders.get(RECEPTION_LOADERS.LIST)
        || this.bm_loaders.get(BM_LOADERS.LIST)
        || this.block_loaders.get(BLOCK_LOADERS.TICKETS)
  }

  async handleInfiniteLoading($state) {
    console.log('ACTIVITY STATUS', this.activityStatus)
    console.log('this.dtInternalSkipNumber****', this.dtInternalSkipNumber)
    console.log('this.coPagination.total ****', this.coPagination.total)
    console.log('this.source.length ****', (this.source || []).length)
    console.log('$state=',$state)
    //if ((this.source || []).length <= this.dtInternalSkipNumber) {
      clearTimeout(this._clearTimeout)
      this._clearTimeout = setTimeout(() => {
        if (!this.isLoading) {
          const $skip = /*(this.source || []).length*/this.dtInternalSkipNumber >= this.coPagination.total ? this.coPagination.total : this.dtInternalSkipNumber
          this.handleLoadMore({
            ...this.coParameter,
            param: {
              ...this.coParameter.param,
              $skip: $skip
            },
            merge: this.dtIsFirstLoad === false
          }, $state);
        }
      }, this.debonce);
    //}
  }

  async handleRefresh(param, debonce?: number) {
    console.log('REFRESH DATA *****************')
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {

      this.dtInternalSkipNumber = 0;
      this.onFetch({
        ...this.coParameter,
        param: {
          ...param,
          $skip: this.dtInternalSkipNumber
        },
        merge: false
      }).then(data => {
        this.dtIsFirstLoad = false;
        this.setLoaderState(false)
        this.dtPreviousParameter = param.param;
        if (data && data.length && this.visible) {
          this.dtInternalSkipNumber = (this.source || []).length//+= this.coPagination.limit;
        }

      }).catch(err => {
        this.dtIsFirstLoad = false;
        this.setLoaderState(false)
      })
    }, debonce ? debonce : this.debonce);
  }
  private handleLoadMore(param, $state) {
    //clearTimeout(this._clearTimeout)
    //this._clearTimeout = setTimeout(() => {
      let promise: Promise<any>
      if (this.dtPreviousParameter === undefined) {
        promise = this.onFetch(param)
      } else {
        const changes = JSONPatch.compare(this.dtPreviousParameter, param)
          .filter(change => change.path.indexOf('$skip') === -1);
        if (changes.length) {
          promise = this.onFetch(param)
        }
      }

      if (promise) {
        promise.then(data => this.handleRespones(data, param, $state)).catch(err => {
          this.dtPreviousParameter = JSON.parse(JSON.stringify(param));
          this.dtIsFirstLoad = false;
          this.setLoaderState(false)
        })
      }
    //}, this.debonce)
  }

  private handleRespones(data, param, $state) {
    console.log('THIS SOURCE = ', this.source)
    console.log('DATA = ', data)
    console.log('this.visible = ', this.visible)
    if (data && data.length/* && this.visible*/) {
      console.log('DATA = ', data)
      console.log('pagination = ', this.coPagination)
      console.log('param = ', param)
      this.dtInternalSkipNumber = param.param.$skip + param.param.$limit
      /*if (this.coPagination)

      if (((this.source || []).length + this.coPagination.limit) < this.coPagination.total) {

      }
      if (this.source.length > 0) {

        this.dtInternalSkipNumber = this.source.length
      } else {
        this.dtInternalSkipNumber = (data || []).length
      }*/
      //this.dtInternalSkipNumber = (this.source || data).length//+= this.coPagination.limit;
    }

    this.dtPreviousParameter = param.param;
    this.dtIsFirstLoad = false;
    this.setLoaderState(false)

    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      $state.loaded();
    }, 300);
  }

  @Watch('coParameter')
  handleParameterChange(newVal, oldVal) {
    const changes = JSONPatch.compare(newVal, oldVal)
      .filter(change => change.path.indexOf('$skip') === -1);

    if (changes.length > 0) {
      this.setLoaderState(true)
      this.handleRefresh(newVal.param, 1000);
    }
  }

  created() {
    this.setLoaderState(true)
  }

  beforeDestroy() {
    /**
   * Reset source before destroy and move to another page
   * Only reset when change different pages, do nothing on parent-children pages
   */
    this.$router.afterEach((to: Route , from: Route) => {
      const fromPath: string = from.path.replace(from.params.id, '').replace(from.params.cid, '');
      const toPath: string = to.path.replace(to.params.id, '').replace(to.params.cid, '');

      if ((fromPath.includes(toPath) === false && toPath.includes(fromPath) === false) || this.force === true) {
        this.dtIsFirstLoad = true;
        this.setLoaderState(false)
        this.resetBeforeDestroy();
      }
    })

  }
}

export default InfinityLoadingComponent;



// WEBPACK FOOTER //
// ./src/components/infinity-loading/index.ts